module.exports = __webpack_public_path__ + "f8f72426a395bb9b2061835e358818f4.pdf";